var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Card",
    { staticClass: "i-content", attrs: { bordered: false, "dis-hover": "" } },
    [
      _vm._t("header"),
      _c(
        "div",
        { staticClass: "i-search-bar" },
        [_vm._t("search"), _vm._t("extra")],
        2
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }